// extracted by mini-css-extract-plugin
export var chevron = "_y-d";
export var disabled = "_y-b";
export var error = "_y-c";
export var hideBorder = "_y-1";
export var icon = "_y-e";
export var input = "_y-0";
export var large = "_y-f";
export var open = "_y-9";
export var placeholder = "_y-a";
export var regular = "_y-5";
export var singleRowInput = "_y-2";
export var singleSelectInput = "_y-3 _y-0";
export var small = "_y-4";
export var spinnerContainer = "_y-i";
export var tag = "_y-7";
export var tagsContainer = "_y-8";
export var tagsInput = "_y-6 _y-0";
export var xSmall = "_y-g";
export var xxSmall = "_y-h";